import React from "react";

import { useDictionary } from "hooks";

import styles from "../ModelerToolbar.css";

export const UnmatchedRulesError = ({ unmatchedRulesData }) => {
	const dictionary = useDictionary("formDesigner.notifications");

	const groupedRulesWithoutMatch = unmatchedRulesData.rulesWithoutMatch.reduce(
		(acc, unmatchedRule) => {
			const ruleId = unmatchedRule.rule.id;

			if (!unmatchedRule.formElement) {
				if (!acc.undefinedRules[ruleId]) {
					acc.undefinedRules[ruleId] = unmatchedRule;
				}
			} else {
				acc.definedRules.push(unmatchedRule);
			}

			return acc;
		},
		{ undefinedRules: {}, definedRules: [] }
	);

	const { undefinedRules, definedRules } = groupedRulesWithoutMatch;

	return (
		<React.Fragment>
			<p
				dangerouslySetInnerHTML={{
					__html: dictionary.unmatchedRules,
				}}
			/>
			<ul className={styles.unmatchedRulesList}>
				{Object.values(undefinedRules).map(rule => {
					const ruleType = rule.rule.ruleType.replaceAll("_", " ");

					return (
						<li key={`${rule.rule.id}-${ruleType}-${rule.rule.orderIndex}`}>
							<div>
								<span>{ruleType}</span>&nbsp; Rule Condition with Order&nbsp;
								<b>{rule.rule.orderIndex}</b>&nbsp; is not connected to any form element.
							</div>
						</li>
					);
				})}

				{definedRules.map(unmatchedRule => {
					const ruleType = unmatchedRule.rule.ruleType.replaceAll("_", " ");

					return (
						<li
							key={`${unmatchedRule.formElement?.label}-${ruleType}-${unmatchedRule.rule.optionId}`}
						>
							<div>
								<span>{unmatchedRule.formElement?.label}</span>
                                &nbsp;in&nbsp;
								<span>
									{unmatchedRule.formElement?.section}
								</span>
                                &nbsp;is not connected to&nbsp;
								<span>{ruleType}</span>&nbsp;Rule
                                Condition with Order&nbsp;<b>{unmatchedRule.rule.orderIndex}</b>
							</div>
						</li>
					);
				})}
			</ul>
		</React.Fragment>
	);
};
